import React, { FC } from 'react';
import { Router, useHistory } from 'react-router';

import { EvIcon } from '@evinced-private/ui-common';

import { handleDashboardRedirection } from 'src/apps/dashboard/helpers/NavigationHelpers';
import { useBannerStore } from 'src/apps/dashboard/stores/bannerStore';
import { ClarificationBanner } from 'src/common/components/clarification-banner/ClarificationBanner';
import InfoMsgMark from 'src/common/components/icons/InfoMsgMark.svg?raw';
import { isConfigurationReady, isDashboardEnabled } from 'src/common/helpers/ConfigurationHelpers';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

import { DashboardRouter } from '../../router/DashboardRouter';
import { DashboardWrapperProps } from '../../types/DashboardTypes';
import { DashboardTabsNav } from '../dashboard-tabs-nav/DashboardTabsNav';

import './DashboardWrapper.scss';

export const DashboardWrapper: FC<DashboardWrapperProps> = () => {
	const history = useHistory();
	const { configuration } = useConfiguration();
	const { visible: isBannerVisible, hidePermanently, setVisible } = useBannerStore();

	if (!isConfigurationReady(configuration)) {
		return null;
	}

	if (!isDashboardEnabled(configuration)) {
		handleDashboardRedirection(history, configuration);
		return null;
	}

	return (
		<div className="dashboard-wrapper">
			{isBannerVisible && (
				<div className="clarification-banner-wrapper">
					<ClarificationBanner hide={() => setVisible(false)} hidePermanently={hidePermanently}>
						<EvIcon icon={InfoMsgMark} small />
						<div className="blurb-text">
							This dashboard shows aggregated data from the Web Flow Analyzer and Web SDKs only.
						</div>
					</ClarificationBanner>
				</div>
			)}

			<div className="navigation-bar-container">
				<DashboardTabsNav />
			</div>

			<div className="dashboard-content">
				<Router history={history}>
					<DashboardRouter />
				</Router>
			</div>
		</div>
	);
};
